import styled from 'styled-components';
import PropTypes from 'prop-types';
import { colors, Item, Tooltip } from '@twnel/web-components';

const SpacedItem = styled(Item)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 3rem;
  padding: 0 1rem;
  ${({ notEvent }) => (notEvent ? 'cursor: default' : '')};

  ${({ lightSelector }) => (lightSelector ? `
    &>:nth-child(${lightSelector}) {
      color: #${colors.blueGray};
    }
  ` : '')}

  & > ${Tooltip} {
    display: flex;
  }
`;

// Sin defaultProps: las interpolaciones CSS tratan `undefined` igual que los
// defaults previos (`null`/`false`), por lo que no hacen falta (React 19 elimina
// defaultProps en componentes función, y los styled lo son en styled-components v6).
SpacedItem.propTypes = {
  lightSelector: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  notEvent: PropTypes.bool,
};

export default SpacedItem;
